<mat-card>
  <mat-card-content>
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
      <mat-card *ngIf="exibirAlertaRetificacao" class="card-warning" style="margin-bottom: 16px;">
        <span>⚠️ Como houve retificação da classificação gerada pelo sistema, é necessário anexar documento gerado pela comissão com resultado final definitivo no andamento sendo criado.</span>
      </mat-card>

      <fieldset fxFlex="100%">
        <legend>Cadastro</legend>
        <div fxLayout="column" fxLayoutGap="5px">
          <mat-form-field appearance="outline">
            <mat-label>Andamento</mat-label>
            <mat-select formControlName="tipo" name="tipo" (selectionChange)="selecionaTipo()">
              <mat-option *ngFor="let type of andamentosPermitidos | keyvalue" [value]="type.key">
                {{ type.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Título</mat-label>
            <input matInput formControlName="titulo" name="titulo" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Complemento</mat-label>
            <input matInput formControlName="complemento" name="complemento" />
          </mat-form-field>

          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill *ngIf="tipoAndamentoDetalhe?.doe">
            <mat-form-field appearance="outline">
              <mat-label>DOE publicação</mat-label>
              <mat-icon class="danger" matPrefix (click)="clearDate('publicacao')">close</mat-icon>
              <input
                matInput
                readonly
                [matDatepicker]="pickerPublicacao"
                formControlName="publicacao"
                name="publicacao" />
              <mat-datepicker-toggle matSuffix [for]="pickerPublicacao"></mat-datepicker-toggle>
              <mat-datepicker #pickerPublicacao></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>DOE página</mat-label>
              <input matInput formControlName="pagina" name="pagina" maxlength="80"/>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>DOE seção</mat-label>
              <input matInput formControlName="sessao" name="sessao" maxlength="80"/>
            </mat-form-field>
          </div>


          <mat-card *ngIf="tipoAndamentoDetalhe?.doe" class="info">
            <span>ℹ️ As informações sobre a publicação no Diário Oficial do Estado (DOE) não são obrigatórias, mas altamente recomendadas para este tipo de andamento</span>
          </mat-card>
          <mat-card *ngIf="tipoAndamentoDetalhe?.recurso" class="info">
              <span>Atentar aos prazos para interposição de recursos pelos candidatos conforme regras do edital e observar feriados e calendário administrativo da UNICAMP.
</span>
          </mat-card>

          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill *ngIf="tipoAndamentoDetalhe?.recurso">
            <mat-form-field appearance="outline">
              <mat-label>Recurso início</mat-label>
              <mat-icon class="danger" matPrefix (click)="clearDate('recursoInicio')">close</mat-icon>
              <input
                matInput
                readonly
                [matDatepicker]="pickerRecursoInicio"
                formControlName="recursoInicio"
                name="recursoInicio" />
              <mat-datepicker-toggle matSuffix [for]="pickerRecursoInicio"></mat-datepicker-toggle>
              <mat-datepicker #pickerRecursoInicio></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Recurso fim</mat-label>
              <mat-icon class="danger" matPrefix (click)="clearDate('recursoFim')">close</mat-icon>
              <input
                matInput
                readonly
                [matDatepicker]="pickerRecursoFim"
                formControlName="recursoFim"
                name="recursoFim" />
              <mat-datepicker-toggle matSuffix [for]="pickerRecursoFim"></mat-datepicker-toggle>
              <mat-datepicker #pickerRecursoFim></mat-datepicker>
            </mat-form-field>
          </div>

          <app-arquivo-upload
            #upload
            [label]="tipoAndamentoDetalhe?.anexoObrigatorio ? 'Anexo *' : 'Anexo'"
            label="Anexo"
            [uploadPath]="andamentoUploadPath"
            accept="application/pdf"
            [fc]="andamentoUploadFc"
            [usarArquivoViewer]="true"></app-arquivo-upload>


          <mat-card *ngIf="tipoAndamentoDetalhe?.anexoObrigatorio" class="card-warning">
            <span>⚠️ Este tipo de andamento exige anexo obrigatório</span>
          </mat-card>
          <mat-checkbox
            *ngIf="form.get('tipo')?.value === 'COMUNICADO'"
            formControlName="notificarApenasPendentes">
            Deseja notificar somente candidatos com inscrições pendentes?
          </mat-checkbox>
        </div>
      </fieldset>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div
      fxLayoutAlign.gt-md="space-between center"
      fxLayoutAlign.lt-md="center stretch"
      fxLayout.lt-md="column"
      fxLayoutGap="20px">
      <ng-container *ngIf="isPermitirAlteracao; then permitirAlteracaoBtn; else salvarCancelarBtns"></ng-container>
      <ng-template #permitirAlteracaoBtn>
        <button mat-raised-button color="primary" (click)="permitirAlteracao()" [disabled]="!isAndamentoConcluido">
          <mat-icon>edit</mat-icon> Reverter
        </button>
        <app-back-button routerLink="../.." color="warn"></app-back-button>
      </ng-template>
      <ng-template #salvarCancelarBtns>
        <button mat-raised-button color="primary" (click)="gravar()" *ngIf="this.id === undefined">
          <mat-icon>add</mat-icon> Adicionar
        </button>
        <button mat-raised-button color="primary" (click)="gravar()" *ngIf="this.id !== undefined">
          <mat-icon>edit</mat-icon> Atualizar
        </button>
        <app-cancel-button (cancel)="cancelar()"></app-cancel-button>
      </ng-template>
    </div>
  </mat-card-actions>
</mat-card>
